import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Mail, Phone, MapPin, Heart, Twitter, Instagram, Youtube, Linkedin, Eye } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        const response = await axios.get(`${API}/visitor/count`);
        setVisitorCount(response.data.count);
      } catch (error) {
        // Silently fail for visitor count - non-critical feature
        setVisitorCount(0);
      }
    };
    
    fetchVisitorCount();
  }, []);
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="/images/logo.png"
                alt="R.P. Educational Welfare Trust"
                className="h-12 w-12 rounded-full mr-3"
              />
              <div>
                <h3 className="text-lg font-bold">R.P. EDUCATIONAL</h3>
                <p className="text-sm text-gray-400">Welfare Trust</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering rural Bihar through education, skill development, and women empowerment since 2022.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/team" className="text-gray-400 hover:text-white transition-colors">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-white transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-gray-400 hover:text-white transition-colors">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <Phone className="mr-2 flex-shrink-0 mt-1" size={16} />
                <span className="text-gray-400">+91 9801133975</span>
              </li>
              <li className="flex items-start">
                <Mail className="mr-2 flex-shrink-0 mt-1" size={16} />
                <span className="text-gray-400">rpeductionalwelfaretrusttrust@gmail.com</span>
              </li>
              <li className="flex items-start">
                <MapPin className="mr-2 flex-shrink-0 mt-1" size={16} />
                <span className="text-gray-400">
                  Gopalganj Thawe Road, GOPALGANJ - 841428, Bihar
                </span>
              </li>
            </ul>
          </div>

          {/* Registration & Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Registration</h4>
            <div className="space-y-2 text-sm text-gray-400 mb-6">
              <p><strong>ID:</strong> BR2502044736</p>
              <p><strong>NITI AAYOG</strong> Registered</p>
              <p><strong>80G & 12A</strong> Certified</p>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-3">Follow Us</h4>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://www.facebook.com/share/p/1BTA1MjBon/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-purple-600 p-2 rounded-full hover:bg-purple-700 transition-colors"
                  title="Facebook"
                >
                  <Facebook size={18} />
                </a>
                <a
                  href="#"
                  className="bg-purple-600 p-2 rounded-full hover:bg-purple-700 transition-colors"
                  title="Twitter"
                >
                  <Twitter size={18} />
                </a>
                <a
                  href="#"
                  className="bg-purple-600 p-2 rounded-full hover:bg-purple-700 transition-colors"
                  title="Instagram"
                >
                  <Instagram size={18} />
                </a>
                <a
                  href="#"
                  className="bg-purple-600 p-2 rounded-full hover:bg-purple-700 transition-colors"
                  title="YouTube"
                >
                  <Youtube size={18} />
                </a>
                <a
                  href="#"
                  className="bg-purple-600 p-2 rounded-full hover:bg-purple-700 transition-colors"
                  title="LinkedIn"
                >
                  <Linkedin size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} R.P. Educational & Welfare Trust. All rights reserved.
            </p>
            
            {/* Visitor Counter */}
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <Eye size={16} className="text-purple-400" />
              <span>
                <strong className="text-purple-400">{visitorCount.toLocaleString()}</strong> Total Visitors
              </span>
            </div>

            <p className="text-gray-500 text-xs flex items-center justify-center">
              Empowering Through Education <Heart className="mx-1 text-red-500" size={14} /> Transforming Lives
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
